import { Instagram, Linkedin, Mail } from "lucide-react";
import { EVENT, SOCIAL_LINKS, WHATSAPP_NUMBER, WHATSAPP_DISPLAY } from "../data/eventData";
import { scrollToId } from "./Motion";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/5 bg-brand-deep" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <img src="/logo-original.png" alt="Pregoeiros Summit" className="h-11 w-auto" data-testid="footer-logo" />
            <p className="mt-5 text-sm text-brand-silver/60 leading-relaxed max-w-xs">
              {EVENT.dateLabel} · Florianópolis · Santa Catarina. A maior experiência em licitações e contratos do Brasil.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                href={SOCIAL_LINKS.instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="h-10 w-10 rounded-full border border-white/10 flex items-center justify-center text-brand-silver/70 hover:text-white hover:border-white/35 transition-all"
                data-testid="footer-instagram"
              >
                <Instagram size={17} />
              </a>
              <a
                href={SOCIAL_LINKS.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="h-10 w-10 rounded-full border border-white/10 flex items-center justify-center text-brand-silver/70 hover:text-white hover:border-white/35 transition-all"
                data-testid="footer-linkedin"
              >
                <Linkedin size={17} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-mono text-[11px] uppercase tracking-[0.28em] text-brand-cyan/80 mb-5">Navegação</h4>
            <ul className="space-y-3 text-sm">
              {[
                ["Autoridades", "#autoridades"],
                ["Galeria", "#galeria"],
                ["O Evento", "#evento"],
                ["Ingressos", "#ingressos"],
                ["Dúvidas frequentes", "#faq"],
              ].map(([label, hash]) => (
                <li key={hash}>
                  <a
                    href={hash}
                    onClick={(e) => { e.preventDefault(); scrollToId(hash); }}
                    className="text-brand-silver/60 hover:text-white transition-colors"
                    data-testid={`footer-link-${hash.slice(1)}`}
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-mono text-[11px] uppercase tracking-[0.28em] text-brand-cyan/80 mb-5">Contato & Realização</h4>
            <a
              href={`mailto:${EVENT.contactEmail}`}
              className="flex items-center gap-2 text-sm text-brand-silver/60 hover:text-white transition-colors"
              data-testid="footer-email"
            >
              <Mail size={14} /> {EVENT.contactEmail}
            </a>
            <a
              href={`https://wa.me/${WHATSAPP_NUMBER}`}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 block text-sm text-brand-silver/60 hover:text-white transition-colors"
              data-testid="footer-whatsapp"
            >
              WhatsApp · {WHATSAPP_DISPLAY}
            </a>
            <div className="mt-7">
              <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-white/30 mb-3">Realização</p>
              <img src="/ceap-white.png" alt="CEAP Brasil" className="h-10 w-auto opacity-90" data-testid="footer-ceap-logo" />
            </div>
          </div>
        </div>

        <div className="mt-14 pt-7 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/30">
            © 2027 Pregoeiros Summit · Todos os direitos reservados
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-white/25">
            {EVENT.edition} · {EVENT.website}
          </p>
        </div>
      </div>
    </footer>
  );
}
